// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6d0cb841","453":"e5370d52"}[chunkId] + ".chunk.js";
};